import { DocumentTextIcon } from '@heroicons/react/outline';

export function DocumentFileIcon() {
  return <DocumentTextIcon className="h-full text-file-text-enabled" />;
}
